import { render, staticRenderFns } from "./productBom.vue?vue&type=template&id=09ac274e"
import script from "./productBom.vue?vue&type=script&lang=js"
export * from "./productBom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports